<template>
  <div
    :class="[
      'card',
      variant && `text-bg-${variant}`,
      border && `border-${border}`,
      props.class,
    ]"
  >
    <slot />
  </div>
</template>

<script setup>
import { THEME_VARIANTS } from '@shared/constants/bootstrap'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  border: {
    type: String,
    required: false,
    default: '',
    validator: (val) => ['', ...THEME_VARIANTS].includes(val),
  },
  variant: {
    type: String,
    required: false,
    default: '',
    validator: (val) => ['', ...THEME_VARIANTS].includes(val),
  },
})
</script>
